import { dataBullseyeHit } from 'dls-icons-data'
import { createIcon } from '../common'

const IconBullseyeHit = /*#__PURE__*/createIcon(dataBullseyeHit)
export default IconBullseyeHit
